module.exports = __webpack_public_path__ + "static/media/galdinsWon_5000_10000.00254ecc.png";